import {Component, Injector} from '@angular/core';
import {NewsState, Store as NewsStore} from './state/store';
import {News} from './state/model';
import {NewsService as NewsService} from './state/service';
import {EntityDetailComponent} from '../../components/entity-detail/component';
import {FormBuilder} from '@angular/forms';
import {NewsQuery} from './state/query';

@Component({
  templateUrl: '../../components/entity-detail/component.html',
  styleUrls: ['../../components/entity-detail/component.scss']
})
export class NewsDetailComponent extends EntityDetailComponent<News, NewsState, NewsStore> {

  constructor(
    public injector: Injector,
    service: NewsService,
    protected query: NewsQuery,
    protected formBuilder: FormBuilder) {
    super(injector, service, query);
  }
}
